<template>
	<div
		class="form-input--wrapper form-input"
		:class="{
			error: !isValid,
			focus: isFocused,
			disabled: disabled,
			...classes,
		}"
	>
		<slot name="leading" />
		<input
			:value="value"
			:type="type"
			:disabled="readonly || disabled"
			:maxlength="maxlength"
			@input="$emit('input', $event.target.value)"
			@change="$emit('change', $event.target.value)"
			@focusin="handleFocusIn"
			@focusout="handleFocusOut"
		>
		<slot name="trailing" />
	</div>
</template>

<script>
export default {
	name:  'FormInput',
	props: {
		isValid: {
			type:     Boolean,
			required: false,
			default:  true,
		},
		value: {
			required: false,
		},
		type: {
			type:    String,
			default: 'text',
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		readonly: {
			type:    Boolean,
			default: false,
		},
		classes: {
			type: Object,
		},
		maxlength: {
			type:    Number,
			default: 524288,
		},
	},
	data() {
		return {
			isFocused: false,
		};
	},
	watch: {
		disabled(val) {
			if (val) {
				this.isFocused = false;
			}
		},
	},
	methods: {
		handleFocusIn(e) {
			if (this.disabled) {
				return;
			}
			this.isFocused = true;
			this.$emit('focusin', e);
		},
		handleFocusOut(e) {
			if (this.disabled) {
				return;
			}
			this.isFocused = false;
			this.$emit('focusout', e);
		},
	},
};
</script>

<style lang="scss" scoped>
.form-input--wrapper {
	display: flex !important;

	input {
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1 1 auto;
		margin-right: 25px;
		width: 100%;
	}
}
</style>
